import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // scroll to top on page load or change of route
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);
}

export default ScrollToTop;
